module.exports = "\r\n\r\n<h1>Demo Page</h1>\r\n\r\n\r\n\r\n\r\n<h3>Buttons</h3>\r\n\r\n<p>\r\n  <button mat-raised-button>Hello</button>\r\n  <button mat-fab><mat-icon>check</mat-icon></button>\r\n  <button mat-icon-button><mat-icon>check</mat-icon></button>\r\n</p>\r\n\r\n\r\n<h2>Time is: {{time}}</h2>\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/demo-page/demo-page.html
// module id = ../../../../../src/app/sample/containers/demo-page/demo-page.html
// module chunks = main